import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { useLanguage } from '../../hooks/useLanguage';
import { GalleryProject } from '../../data/gallery';
import { ui } from '../../data/translations';
type GalleryLightboxProps = {
  project: GalleryProject;
  onClose: () => void;
};
export function GalleryLightbox({
  project,
  onClose
}: GalleryLightboxProps) {
  const {
    t
  } = useLanguage();
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);
  return <motion.div role="dialog" aria-modal="true" aria-labelledby="lightbox-title" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-navy-deep/90 p-4 sm:p-8" onClick={onClose} data-id="element-122" data-mp="sual4al47wmr">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="w-full max-w-5xl overflow-hidden rounded-lg bg-white" onClick={e => e.stopPropagation()} data-id="element-123" data-mp="17qa0856n6x1e">
        <BeforeAfterSlider before={project.before} after={project.after} alt={t(project.title)} beforeLabel={t(ui.gallery.before)} afterLabel={t(ui.gallery.after)} dragLabel={t(ui.gallery.drag)} className="aspect-[4/3] max-h-[75vh] w-full" data-id="element-124" data-mp="ospe35v9ickh" />
        <div className="flex items-center justify-between gap-4 px-5 py-4 sm:px-6" data-id="element-125" data-mp="3kfjdvc9nmxue">
          <div data-id="element-126" data-mp="3fi1bk4q57gvd">
            <h3 id="lightbox-title" className="font-display text-lg font-semibold text-navy" data-id="element-127" data-mp="3fggm2tioqo4d">
              {t(project.title)}
            </h3>
            <p className="text-sm text-steel" data-id="element-128" data-mp="3u88ns2pk43nm">{t(project.description)}</p>
          </div>
          <button ref={closeRef} type="button" onClick={onClose} aria-label={t(ui.gallery.close)} className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md border border-black/15 text-navy transition-colors duration-150 hover:bg-mist" data-id="element-129" data-mp="3p9e5r2zeyj4k">
            <XIcon className="h-5 w-5" data-id="element-130" data-mp="36gthjyunt273" />
          </button>
        </div>
      </motion.div>
    </motion.div>;
}